export default "__VITE_ASSET__aR3XZCVS__"